export default "__VITE_ASSET__ozIrumP4__"